module.exports = __webpack_public_path__ + "static/media/travel2.ee70a87c.jpg";